import { applyDiscount } from '../../../../helpers';
import {
  DiscountCodeDto,
  EventForUser,
  MultiTierCheckoutSession
} from '../../../../types';
import { trackTransaction } from 'legacy/common/utils/ga';

/**
 * Logs a transaction to Google Analytics.
 */
const logTransactionToGA = (
  checkoutSession: MultiTierCheckoutSession,
  event: EventForUser,
  discountData: DiscountCodeDto
) => {
  const items = Object.keys(checkoutSession?.ticketBasket || {}).map(
    (ticketId) => {
      const selectedTier = event?.pricing?.tiers.find(
        (tier) => tier._id === ticketId
      );

      return {
        id: ticketId,
        name: `${event?._id}-${selectedTier.name}`,
        quantity: checkoutSession.ticketBasket[ticketId],
        price: applyDiscount(selectedTier.price, discountData)?.toFixed(2)
      };
    }
  );

  trackTransaction({
    id: checkoutSession.paymentIntentId,
    affiliation: 'Bounce Web',
    currency: checkoutSession.currency,
    tax: checkoutSession.pricing.taxes.toFixed(2),
    value: checkoutSession.total.toFixed(2),
    items
  });
};

export default logTransactionToGA;
